export const appActionTypes = {
  SET_TRANSCRIPT_DATA: "SET_TRANSCRIPT_DATA",
  SET_TRANSCRIPT_STATUS: "SET_TRANSCRIPT_STATUS",
  INTEGRATE_CALENDAR_POPUP: "INTEGRATE_CALENDAR_POPUP",
  SET_APP_SETTINGS: "SET_APP_SETTINGS",
};
